import "./App.css";
import App from "./App";
import Header from "./Header";
import Footer from "./Footer";

import { BrowserRouter as Router, Routes, Route } from "react-router";
import Login from "./Login";

function AppRouter() {
  return (
    <Router>
    <Header />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/build/login" element={<Login />} />
        <Route path="/build" element={<App />} />
        <Route path="/" element={<App />} />
      </Routes>
    <Footer />
    </Router>
  );
}

export default AppRouter;

